import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { Navigation } from 'app/core/navigation/navigation.types';
import { cloneDeep } from 'lodash';
import { BehaviorSubject, Observable, ReplaySubject, of } from 'rxjs';
import { defaultNavigation } from './navigation.data';
import { UserService } from '../user/user.service';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> =
        new ReplaySubject<Navigation>(1);
    private readonly _compactNavigation: FuseNavigationItem[] =
        defaultNavigation;
    private _defaultNavigation: FuseNavigationItem[] =
        defaultNavigation;
    private _tmpDefaultNavigation: FuseNavigationItem[] = defaultNavigation;

    private userRole = new BehaviorSubject<any>(null);
    private role = [];
    private navigationItems: FuseNavigationItem[] = [];

    /**
     * Constructor
     */
    constructor(private _httpClient: HttpClient, private _userService: UserService) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for navigation
     */
    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    get userData(): Observable<any> {
        return this.userRole.asObservable();
    }

    getRoleList(): Observable<any> {
        return this._httpClient.get<[]>(
            environment.apiBaseUrl + '/manage-role/role-list'
        );
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get all navigation data
     */
    // get(): Observable<Navigation> {
    //     this.navigationItems = this._defaultNavigation;

    //     const compact = cloneDeep(this._compactNavigation).filter((compactNavItem) => {
    //         compactNavItem['type'] = compactNavItem.children ? 'aside' : 'basic';
    //         let match = false;
    //         this._defaultNavigation.forEach((defaultNavItem) => {
    //             if (defaultNavItem.id === compactNavItem.id) {
    //                 compactNavItem.children = cloneDeep(
    //                     defaultNavItem.children
    //                 );
    //                 match = true;
    //             }
    //         });
    //         return match;
    //     });

    //     const navigationItem = {
    //         compact: compact,
    //         default: cloneDeep(this.navigationItems),
    //         futuristic: cloneDeep(this.navigationItems),
    //         horizontal: cloneDeep(this.navigationItems),
    //     };

    //     // Return the response
    //     this._navigation.next(navigationItem);
    //     return of(navigationItem);

    // }


    async get(): Promise<any> {
        await this._userService.user$.subscribe((user: any) => {
            if (user) {
                // display navigation menu by user login
                if (user.isSuperAdmin === true) { // If super admin login
                    this.userRole.next({ isSuperAdmin: true });
                    this.navigationItems = this._tmpDefaultNavigation;

                    const compact = cloneDeep(this._compactNavigation).filter((compactNavItem) => {
                        compactNavItem['type'] = compactNavItem.children ? 'aside' : 'basic';
                        let match = false;
                        this.navigationItems.forEach((defaultNavItem) => {
                            if (defaultNavItem.id === compactNavItem.id) {
                                compactNavItem.children = cloneDeep(defaultNavItem.children);
                                match = true;
                            }
                        });
                        return match;
                    });

                    const navigationItem = {
                        compact: compact,
                        default: cloneDeep(this.navigationItems),
                        futuristic: cloneDeep(this.navigationItems),
                        horizontal: cloneDeep(this.navigationItems),
                    };

                    // Return the response
                    this._navigation.next(navigationItem);
                    return of(navigationItem);

                } else {
                    this.role = [];
                    this.role.push('/dashboard');
                    this.getRoleList().subscribe((data: any) => {
                        const roleData = data.data.filter(element => element.id === user.role_id);
                        const role = roleData[0]?.section_list;
                        const dashboardArr: any[] = [] = role.filter(element => element.rout_path === '/dashboard' && element.isAccessable === true);
                        let isDashboard = false;
                        if (dashboardArr.length > 0) { isDashboard = true; }
                        role.map((x) => {
                            if (x.isAccessable === true) { return this.role.push(x.route_path); }
                        });
                        this._defaultNavigation = cloneDeep(this._tmpDefaultNavigation).filter((obj) => {
                            if (obj.children && obj.children.length > 0) {
                                obj.children = obj.children.filter((objChild) => {
                                    if (objChild.children && objChild.children.length > 0) {
                                        objChild.children = objChild.children.filter(child => this.role.includes(child.link));
                                        return objChild.children.length > 0;
                                    } else {
                                        return this.role.includes(objChild.link);
                                    }
                                });
                                return obj.children.length > 0;
                            } else {
                                return this.role.includes(obj.link);
                            }
                        });
                        const tempUserData = {
                            permissionLevel: role,
                            pageLavel: this.role,
                            isDashboard
                        };
                        this.userRole.next(tempUserData);
                        this.navigationItems = this._defaultNavigation;

                        const compact = cloneDeep(this._compactNavigation).filter((compactNavItem) => {
                            compactNavItem['type'] = compactNavItem.children ? 'aside' : 'basic';
                            let match = false;
                            this.navigationItems.forEach((defaultNavItem) => {
                                if (defaultNavItem.id === compactNavItem.id) {
                                    compactNavItem.children = cloneDeep(defaultNavItem.children);
                                    match = true;
                                }
                            });
                            return match;
                        });

                        const navigationItem = {
                            compact: compact,
                            default: cloneDeep(this.navigationItems),
                            futuristic: cloneDeep(this.navigationItems),
                            horizontal: cloneDeep(this.navigationItems),
                        };

                        // Return the response
                        this._navigation.next(navigationItem);
                        return of(navigationItem);
                    });
                }
            }
        });

    }
}
